import { Service } from '../classes';

export class SysAsyncService extends Service {
    private _promises: { [key: string]: Promise<void> } = {};

    public static get $name(): string {
        return 'sysAsync';
    }

    public static get $inject(): string[] {
        return ['$document', '$timeout'];
    }

    constructor(
        private $document: JQuery,
        private $timeout: any
    ) {
        super();
    }

    public loadScript(src: string): Promise<void> {
        if (!this._promises[src]) {
            this._promises[src] = new Promise((resolve, reject) => {
                const timeout = this.$timeout(() => {
                    reject(`Async load was failed, '${src}' script timeout`);
                }, 1000);
                this._runScript(src, () => {
                    this.$timeout.cancel(timeout);
                    resolve();
                });
            });
        }
        return this._promises[src];
    }

    private _runScript(url: string, callback: any): void {
        const head = this.$document[0].getElementsByTagName('head')[0];
        const script = (this.$document[0] as unknown as Document).createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        (script as any).onreadystatechange = callback;
        script.onload = callback;
        head.appendChild(script);
    }
}
